import './Task.css';
import { TaskModel, TaskType } from '../../api/models/task/taskmodel';
import { timespanToHumanReadable } from '../../util/TimeUtil';
import { useEffect, useState } from 'react';

type TaskProps = {
    task: TaskModel;
    completions: number;
    completionsThisWeek: number;
    admin: boolean;
    onSelect: () => void;
};

const Task = ({ task, completions, completionsThisWeek: completionsToday, admin, onSelect }: TaskProps) => {
    const [expiryString, setExpiryString] = useState<string | undefined>(undefined);

    const updateExpiryString = () => {
        if (!task.timeLimit) {
            setExpiryString(undefined);
            return;
        }

        setExpiryString(timespanToHumanReadable(task.timeLimit - Date.now()));
    }

    useEffect(() => {
        let interval: any = null;

        updateExpiryString();
        interval = setInterval(updateExpiryString, 1000);

        return () => clearInterval(interval);
    }, [task.timeLimit]);

    const oneOff = task.type === TaskType.OneOff;
    const effectiveCompletions = oneOff ? completions : completionsToday;

    const minCompletions = oneOff ? 0 : Math.max(task.minimumPerWeek ?? 0, 0);
    const maxCompletions = oneOff ? 1 : Math.max(0, task.maximumPerWeek ?? 0);
    const footerText = () => {
        if (task.timeLimit) {
            return <span className="negative">Complete within {expiryString}</span>;
        } else if (task.type === TaskType.Repeatable) {
            if (minCompletions && maxCompletions) {
                return <span className="negative">Required {minCompletions} to {maxCompletions} times per week</span>;
            }
            if (task.minimumPerWeek) {
                return <span className="negative">Min {task.minimumPerWeek} time{task.minimumPerWeek !== 1 ? "s" : ""} per week</span>;
            }
            if (task.maximumPerWeek) {
                return <span>Max {task.maximumPerWeek} time{task.maximumPerWeek !== 1 ? "s" : ""} per week (optional)</span>;
            }
            return <span>Repeatable with no limit</span>;
        } else {
            return <span>Completable once</span>;
        }
    }

    const disabled = !admin && maxCompletions > 0 && effectiveCompletions >= maxCompletions;
    return (
        oneOff && disabled ? <></> : <div className={`task${disabled ? " disabled" : ""}`} onClick={!disabled ? onSelect : undefined}>
            <div className="header">
                <div className="title">
                    {task.emoji && <span className="emoji">{task.emoji}</span>}
                    <span className="name">{task.name}</span>
                    <span className={`completions ${minCompletions > 0 ? "negative" : "secondary"}`}>{effectiveCompletions}/{minCompletions > 0 ? minCompletions : maxCompletions}</span>
                </div>
            </div>
            <span className="reward">Reward: <span className="positive">{task.reward.points} Point{task.reward.points !== 1 ? "s" : ""}</span></span>
            <p className="description">{task.description}</p>
            <div className="footer">
                {footerText()}
            </div>
        </div>
    )
};

export default Task;